/**
 * Generated runtime TestId mirror for frontend/src/features/service-accounts/components/AssignRoleDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const AssignRoleDialogTestIds = {
  assignRoleCombobox: "assign-role-combobox",
  assignRoleDialogTitle: "assign-role-dialog-title",
  assignRoleForm: "assign-role-form",
  assignRoleInlineError: "assign-role-inline-error"
} as const;
